import * as tslib_1 from "tslib";
import { Component, Prop, Ref, Vue } from "vue-property-decorator";
import TreeDialog from "./TreeDialog.vue";
import Tree from "./Tree.vue";
let GroupTree = class GroupTree extends Vue {
    constructor() {
        super(...arguments);
        this.rootKey = '0';
        this.defaultProps = {
            children: 'children',
            label: 'label',
        };
        this.showBtnList = [];
        this.showEditDialog = false;
        this.showDelDialog = false;
        this.showAddDialog = false;
        this.nodes = [];
        this.searchNodes = [];
        this.curId = this.rootKey;
        this.curIndex = 1;
        this.newGroupName = '';
        this.editGroupName = '';
        this.nodeMap = new Map();
        this.maxLength = 40;
        this.groupName = '';
        this.mode = 'normal';
        this.clientX = 0;
        this.clientY = 0;
        this.defaultExpandedKey = [this.rootKey];
        this.nodeOffsetTop = 0;
        this.isDefaultItemEnd = false;
        this.isTopLevelGroup = false;
        this.needStayPage = false;
        this.clickIsTrusted = true;
        this.isFirstLoad = true;
    }
    get emptyImage() {
        return require("@/assets/empty.png");
    }
    get renderNodes() {
        return 'search' === this.mode ? this.searchNodes : this.nodes;
    }
    get typeName() {
        return this.title.substring(0, 2);
    }
    created() {
        this.getTreeList();
        this.$on('$_inner_operate_complete', (callback) => {
            callback(this.renderNodes);
        });
    }
    mounted() {
        document.addEventListener('click', (evt) => {
            const target = evt.target;
            if ('menu' !== target.className) {
                this.showBtnList = this.showBtnList.map(() => false);
            }
        });
    }
    addTopLevelGroup(evt) {
        this.isTopLevelGroup = true;
        this.showAddGroup(evt, this.rootKey);
    }
    back() {
        this.mode = 'normal';
        this.searchNodes = [];
    }
    getSearchTree(callback) {
        const data = {
            keyword: this.groupName,
        };
        const handler = (list) => {
            this.searchNodes = list;
            this.$emit('on-tree-change', this.renderNodes);
            callback && this.$emit('$_inner_operate_complete', callback);
        };
        this.mode = 'search';
        this.$emit('on-search', data, handler);
    }
    isDefaultItem(nodeData) {
        return !(!nodeData || '*' !== nodeData.app_id);
    }
    getNodeIndex(nodeId) {
        return this.nodeMap.get(nodeId) && this.nodeMap.get(nodeId).index;
    }
    getTreeList(callback) {
        const formator = (nodes, index, depth) => {
            let result = [];
            for (let i = 0; i < nodes.length; i++) {
                const node = nodes[i];
                result.push({
                    id: node.id,
                    name: node.name,
                    depth: depth,
                    isLeaf: !(Array.isArray(nodes[i].children) && nodes[i].children.length > 0),
                    parentId: node.parentId || this.rootKey,
                    categoryCount: node.total,
                    index: index++,
                });
                if (Array.isArray(nodes[i].children)) {
                    result = result.concat(formator(nodes[i].children, index, depth + 1));
                }
                index = result[result.length - 1].index + 1;
                this.showBtnList.push(false);
            }
            return result;
        };
        const handler = (list) => {
            this.nodes = [];
            for (let i = 0; i < list.length; i++)
                this.nodes.push(list[i]);
            const nodeList = formator(this.nodes, 0, 0);
            // console.log('nodeList', nodeList)
            nodeList.forEach((node) => {
                this.nodeMap.set(node.id, {
                    name: node.name,
                    depth: node.depth,
                    isLeaf: node.isLeaf,
                    categoryCount: node.categoryCount,
                    index: node.index,
                    parentId: node.parentId,
                });
            });
            const rootKey = sessionStorage.getItem(this.storageKey) || this.rootKey;
            this.$nextTick(() => {
                const treeEl = this.getTreeComponent();
                const node = treeEl.getNode(rootKey);
                this.curId = (node && node.id) || this.rootKey;
                if (node) {
                    treeEl.setCurrentKey(this.curId);
                    this.defaultExpandedKey = [node.data.id];
                    setTimeout(() => {
                        const nodeEl = document.querySelector(`#tree-node-id-${rootKey}`);
                        this.clickIsTrusted = false;
                        nodeEl && nodeEl.click();
                    }, 1);
                }
                else {
                    const nodeEl = document.querySelector(`#tree-node-id-${rootKey}`);
                    this.clickIsTrusted = false;
                    nodeEl && nodeEl.click();
                }
                if (this.isFirstLoad) {
                    this.isFirstLoad = false;
                    this.$emit('on-init', this.renderNodes);
                    this.$emit('on-tree-change', this.renderNodes);
                }
                callback && this.$emit('$_inner_operate_complete', callback);
                this.$emit('sync-tree-node-map', this.nodeMap);
            });
        };
        this.$emit('on-get-data', handler);
    }
    emitList(data, node) {
        if (!data.isLine) {
            node.isLeaf;
            const nodeId = data.id;
            const nodeKey = sessionStorage.getItem(this.storageKey) || this.rootKey;
            if (nodeKey) {
                const nodeEl = document.getElementById(`tree-node-id-${nodeKey}`);
                if (nodeEl) {
                    nodeEl.parentNode.classList.remove('select-status');
                    sessionStorage.setItem(this.storageKey, nodeId);
                    this.$emit('on-node-click', data, node);
                }
            }
        }
    }
    select(evt, node, nodeData) {
        const nodeEl = document.getElementById(`tree-node-id-${nodeData.id}`);
        this.nodeOffsetTop = nodeEl.offsetTop + 90;
        this.clientX = evt.clientX;
        this.clientY = evt.clientY;
        this.curId = nodeData.id;
        this.curIndex = this.nodeMap.get(nodeData.id).index;
        this.showEditDialog = false;
        this.showAddDialog = false;
        this.showDelDialog = false;
        this.showBtnList = this.showBtnList.map((state, idx) => {
            return idx === this.curIndex - 1 && !state;
        });
        this.$forceUpdate();
    }
    addGroup() {
        if (!this.newGroupName)
            return this.$message.error('请填写分类名称');
        var data = {
            parentId: this.curId,
            name: this.newGroupName,
        };
        this.isTopLevelGroup = false;
        this.showAddDialog = false;
        var handler = () => {
            sessionStorage.setItem(this.storageKey, `${data.parentId}`);
            this.refreshTree().then(() => {
                this.$emit('on-tree-change', this.renderNodes);
            });
        };
        this.$emit('on-add', data, handler);
        this.newGroupName = '';
    }
    hideMenu() {
        this.showBtnList = this.showBtnList.map(() => false);
    }
    showEdit(evt) {
        this.clientX = evt.clientX;
        this.clientY = evt.clientY;
        this.showEditDialog = true;
        this.hideMenu();
        this.editGroupName = this.nodeMap.get(this.curId).name;
    }
    editGroup() {
        if (!this.editGroupName)
            return this.$message.warning('请填写分类名称');
        const treeEl = this.getTreeComponent();
        const node = treeEl.getNode(this.curId) || {
            data: '',
        };
        const data = {
            id: this.curId,
            name: this.editGroupName,
            parentId: node.data.parentId,
        };
        this.showEditDialog = false;
        var handler = () => {
            this.needStayPage = true;
            this.refreshTree().then(() => {
                this.$emit('on-tree-change', this.renderNodes);
            });
        };
        this.$emit('on-update', data, handler);
    }
    showAddGroup(evt, nodeId) {
        this.clientX = evt.clientX;
        this.clientY = evt.clientY;
        this.curId = nodeId;
        this.curIndex = this.nodeMap.get(nodeId).index;
        this.showAddDialog = true;
    }
    closeAddDialog() {
        this.showAddDialog = false;
        this.isTopLevelGroup = false;
        this.newGroupName = '';
    }
    closeEditDialog() {
        this.editGroupName = '';
        this.showEditDialog = false;
        this.hideMenu();
        this.$forceUpdate();
    }
    handleDeleteCategory() {
        const node = this.nodeMap.get(this.curId);
        if (!node.isLeaf || node.categoryCount > 0) {
            this.hideMenu();
            this.$emit('on-delete-fail', node);
            return;
        }
        this.handleDeleteCategoryConfirm();
    }
    async handleDeleteCategoryConfirm() {
        try {
            await this.$confirm('删除后不可恢复。', {
                type: 'error',
                title: '确认删除该分类吗？',
                cancelButtonText: '取消',
                confirmButtonText: '删除',
                confirmButtonClass: 'confirm-cancel-button',
            });
            this.deleteCategory();
        }
        catch (error) {
        }
    }
    deleteCategory() {
        const data = {
            id: this.curId,
        };
        const parentId = this.nodeMap.get(this.curId).parentId;
        const handler = () => {
            var nodeKey = sessionStorage.getItem(this.storageKey);
            if (nodeKey === this.curId) {
                sessionStorage.setItem(this.storageKey, parentId || this.rootKey);
            }
            this.refreshTree().then(() => {
                this.$emit('on-tree-change', this.renderNodes);
            });
        };
        this.$emit('on-delete', data, handler);
    }
    refreshTree() {
        var e = this;
        return new Promise((resolve) => {
            'search' !== e.mode ? e.getTreeList(resolve) : e.getSearchTree(resolve);
        });
    }
    getTreeComponent() {
        return this.tree.getTreeComponent();
    }
};
tslib_1.__decorate([
    Prop({ type: String, default: '分类' })
], GroupTree.prototype, "title", void 0);
tslib_1.__decorate([
    Prop({ type: String, default: '' })
], GroupTree.prototype, "storageKey", void 0);
tslib_1.__decorate([
    Prop({ type: [Number, String], default: '0' })
], GroupTree.prototype, "rootKey", void 0);
tslib_1.__decorate([
    Prop({ type: Array, default: () => ['', '1', '0', 1, 0] })
], GroupTree.prototype, "readonlyList", void 0);
tslib_1.__decorate([
    Prop({ type: Number, default: 5 })
], GroupTree.prototype, "depth", void 0);
tslib_1.__decorate([
    Prop({ type: Number, default: 14 })
], GroupTree.prototype, "fontLength", void 0);
tslib_1.__decorate([
    Prop({ type: Array, default: () => [] })
], GroupTree.prototype, "defaultCheckedKeys", void 0);
tslib_1.__decorate([
    Ref()
], GroupTree.prototype, "tree", void 0);
GroupTree = tslib_1.__decorate([
    Component({
        name: 'GroupTree',
        components: {
            TreeDialog,
            Tree
        },
        filters: {
            dialogStyle(e) {
                var t = 170;
                return `top: ${e >= 16 ? t + 640 : t + 40 * e}px`;
            },
            splitFilename(e) {
                for (var t = /[\da-zA-Z]/, n = 0, r = 0; r < e.length; r++)
                    n < 9 && e.charAt(r), (n += t.test(e.charAt(r)) ? 1 : 2);
                return e;
            },
            getMenuHeight(e, t) {
                var n = 52, r = 40, i = t && t.$el.scrollTop, o = r * (e + 1) + n;
                return `top: ${i > 0 ? o - i : o}px`;
            },
        }
    })
], GroupTree);
export default GroupTree;
